exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3w3TIE9YXtVc_tXsacTCEs{font-size:12px;color:var(--states-color);margin-left:4px}.n5_7NM-cd9v_qrR9z6DYG{color:var(--background-color)}._2NJ7ljCTmWifQUVsrb09JI{background-color:var(--background-color);color:var(--light-danger-color)}._3RoWLugD9s7hbW_UrU30jZ{background-color:var(--background-color);color:var(--primary-text-color)}", ""]);

// Exports
exports.locals = {
	"totalEvents": "_3w3TIE9YXtVc_tXsacTCEs",
	"totalEventsNotify": "n5_7NM-cd9v_qrR9z6DYG",
	"badgeAssailant": "_2NJ7ljCTmWifQUVsrb09JI",
	"badgeTrain": "_3RoWLugD9s7hbW_UrU30jZ"
};